import { InsuranceAddress } from "./InsuranceAddress";

export class InterestedParty {
  firstName = "";
  lastName = "";
  address = new InsuranceAddress();
}
